import { render, staticRenderFns } from "./location.vue?vue&type=template&id=6a86216c"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a86216c')) {
      api.createRecord('6a86216c', component.options)
    } else {
      api.reload('6a86216c', component.options)
    }
    module.hot.accept("./location.vue?vue&type=template&id=6a86216c", function () {
      api.rerender('6a86216c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/location.vue"
export default component.exports